/* eslint-disable prettier/prettier */
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import HyperlinkForModulePermission from "@/views/apps/employees/RRHH/Modules/hyperLink/HyperlinkForModulePermission.vue";

// import { formatDate } from "@/utils";

export default [
  {
    prop: "Name",
    label: "Empleado",
    sortable: true,
    formatter: ImagePerson,
    width: 200,
    fixed: true,
    attrs: {
      imgKey: "imageUrl"
    }
  },
  {
    prop: "DiasSolicitados",
    label: "Dias Solicitados",
    width: 160,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "HorasSolicitadas",
    label: "Horas Solicitadas",
    width: 160,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "Enero",
    label: "Enero",
    width: 125,
    sortable: true,
    cellAtrrs: {
      mes: 1
    },
    formatter: HyperlinkForModulePermission
  },
  {
    prop: "Febrero",
    label: "Febrero",
    width: 125,
    sortable: true,
    cellAtrrs: {
      mes: 2
    },
    formatter: HyperlinkForModulePermission
  },
  {
    prop: "Marzo",
    label: "Marzo",
    width: 125,
    sortable: true,
    cellAtrrs: {
      mes: 3
    },
    formatter: HyperlinkForModulePermission
  },
  {
    prop: "Abril",
    label: "Abril",
    width: 125,
    sortable: true,
    cellAtrrs: {
      mes: 4
    },
    formatter: HyperlinkForModulePermission
  },
  {
    prop: "Mayo",
    label: "Mayo",
    width: 125,
    sortable: true,
    cellAtrrs: {
      mes: 5
    },
    formatter: HyperlinkForModulePermission
  },
  {
    prop: "Junio",
    label: "Junio",
    width: 125,
    sortable: true,
    cellAtrrs: {
      mes: 6
    },
    formatter: HyperlinkForModulePermission
  },
  {
    prop: "Julio",
    label: "Julio",
    sortable: true,
    width: 125,
    cellAtrrs: {
      mes: 7
    },
    formatter: HyperlinkForModulePermission
  },

  {
    prop: "Agosto",
    label: "Agosto",
    width: 125,
    sortable: true,
    cellAtrrs: {
      mes: 8
    },
    formatter: HyperlinkForModulePermission
  },
  {
    prop: "Septiembre",
    label: "Septiembre",
    width: 125,
    sortable: true,
    cellAtrrs: {
      mes: 9
    },
    formatter: HyperlinkForModulePermission
  },
  {
    prop: "Octubre",
    label: "Octubre",
    width: 125,
    sortable: true,
    cellAtrrs: {
      mes: 10
    },
    formatter: HyperlinkForModulePermission
  },
  {
    prop: "Noviembre",
    label: "Noviembre",
    width: 125,
    sortable: true,
    cellAtrrs: {
      mes: 11
    },
    formatter: HyperlinkForModulePermission
  },
  {
    prop: "Diciembre",
    label: "Diciembre",
    width: 125,
    sortable: true,
    cellAtrrs: {
      mes: 12
    },
    formatter: HyperlinkForModulePermission
  }
];
